import { render, staticRenderFns } from "./commissionCharteredBus.vue?vue&type=template&id=8dc352ae"
import script from "./commissionCharteredBus.vue?vue&type=script&lang=js"
export * from "./commissionCharteredBus.vue?vue&type=script&lang=js"
import style0 from "./commissionCharteredBus.vue?vue&type=style&index=0&id=8dc352ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports